import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import "./CustomModal.css";

const CustomModal = ({
  open,
  onClose,
  title,
  maxWidth = "md",
  showCloseButton = true,
  customStyles = {},
  actions = [],
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      classes={{ paper: "custom-modal-content" }}
      sx={{
        ...customStyles,
        "& .MuiDialog-container": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
    >
      {title && (
        <DialogTitle className="custom-modal-title">{title}</DialogTitle>
      )}
      {showCloseButton && (
        <button
          className="custom-modal-close-button"
          onClick={onClose}
          aria-label="Close Modal"
        >
          &times;
        </button>
      )}
      <DialogContent>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              {children || null}
            </motion.div>
          )}
        </AnimatePresence>
      </DialogContent>
      {actions.length > 0 && (
        <DialogActions className="custom-modal-actions">
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.onClick}
              color={action.color}
              variant={action.variant}
              sx={action.sx}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomModal;
